<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="项目名称:" :label-width="78">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目编号:">
                        <Input v-model="formInline.projectCode" placeholder="请输入项目编号"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目类型:">
                        <Select v-model="formInline.category" placeholder="请选择项目类型" filterable>
                            <Option value="房屋建筑工程">房屋建筑工程</Option>
                            <Option value="市政公用工程">市政公用工程</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
              <!-- <Col span="6">
                    <FormItem label="项目状态:" :label-width="78">
                        <Select v-model="formInline.prjStatus" placeholder="请选择项目状态" filterable>
                            <Option value="筹备">筹备</Option>
                            <Option value="立项">立项</Option>
                            <Option value="在建">在建</Option>
                            <Option value="完工">完工</Option>
                            <Option value="停工">停工</Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <!-- <Col span="6">
                    <FormItem label="考勤时间:">
                        <DatePicker type="date" placeholder="请选择考勤开始时间" v-model="formInline.startDate" style="width: calc(50% - 6px);margin-right: 12px;" @on-change='handleStartDate' :options='{
                            disabledDate: disabledDateStart
                        }'></DatePicker>
                        <DatePicker type="date" placeholder="请选择考勤结束时间" v-model="formInline.endDate" style="width: calc(50% - 6px);" @on-change='handleEndDate' :options='{
                            disabledDate: disabledDateEnd
                        }'></DatePicker>
                    </FormItem>
                </Col> -->
                <!-- <Col span="6">
                    <FormItem label="是否考勤:">
                        <Select v-model="formInline.isKq" placeholder="请选择是否考勤" filterable>
                            <Option value="是">是</Option>
                            <Option value="否">否</Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <Col span="6">
                    <FormItem label="项目所在地:">
                       <Input v-model="areaName" disabled></Input>
                        <!-- <Select v-model="formInline.areaCode" filterable transfer placeholder="请选择地区">
                            <Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>
                        </Select> -->
                    </FormItem>
                </Col>
                <Col span="6">
                    <Button style="margin-bottom: 24px;" icon="ios-exit-outline" type="primary" @click="handleExport">导出</Button>
                </Col>
            </Row>
            <!-- <Row>
                
            </Row> -->
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading"  :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="scope" slot="manager">
                    <span v-html="scope.row.manager"></span>
                </template>
                <template slot-scope="scope" slot="chiefInspector">
                    <span v-html="scope.row.chiefInspector"></span>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row,row.id)">详情</span>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';

    export default {
        mixins: [tableMixin],
        data(){
            return {
                open: false,
                formInline:{
                    areaCode: this.$route.query.areaCode,// 地区
                    current: 1,
                    endDate: "",// 结束时间
                    projectName: "",// 项目名称
                    size: 10,
                    startDate: "",// 开始时间
                    projectCode: "",// 项目编号
                    category: "",// 类型
                    prjStatus: "在建",// 项目状态
                    isKq: ""// 是否考勤:是,否
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '项目名称', key: 'name', minWidth: 210, tooltip: true },
                    { title: '项目编号', key: 'projectCode', width:180, tooltip: true },
                    { title: '项目类型', key: 'category', minWidth: 180, tooltip: true },
                    { title: '项目属地', key: 'areaName', minWidth: 140, tooltip: true },
                    { title: '项目状态', key: 'prjStatus', minWidth: 100 },
                    { title: '是否设置项目经理', key: 'isManager', width: 210, tooltip: true

                    },
                    // { title: '项目经理姓名', key: 'managerName', minWidth: 210 },
                    // { title: '项目经理身份证号', key: 'managerCard',  minWidth:210 },
                    {title:"项目经理",key:"manager",slot:'manager',minWidth: 260 },
                    { title: '是否设置总监理工程师', key: 'isChiefInspector', minWidth: 210 },
                     { title: '总监理工程师', key: 'chiefInspector', tooltip: true ,minWidth: 260,
                      slot:'chiefInspector'
                    },

                    // { title: '总监理工程师姓名', key: 'chiefInspectorName', minWidth: 210, tooltip: true ,

                    // },
                    //   { title: '总监理工程师身份证号', key: 'chiefInspectorCard', minWidth: 210, tooltip: true ,

                    // },
                    { title: '操作', slot: 'action', fixed: 'right', minWidth:100 }
                ],
                // aa:'',
                tableData: [],
                areaName:this.$route.query.areaName
            };
        },
        computed:{
            ...mapState(['navList','area','citys','areaCode'])
        },
        created(){

        },
        mounted(){

        },
        watch: {

        },
        methods: {
            disabledDateStart(val) {
                return new Date(this.formInline['endDate'] || '').getTime() < val.getTime()
            },
            disabledDateEnd(val) {
                return new Date(this.formInline['startDate'] || '').getTime() > val.getTime()
            },
            handleStartDate(val) {
                this.formInline['startDate'] = val
            },
            handleEndDate(val) {
                this.formInline['endDate'] = val
            },
            handleReset() {
                this.pageSize = 10
                this.page = 1
                this.formInline = {
                    areaCode:this.$route.query.areaCode,// 地区
                    current: 1,
                    endDate: "",// 结束时间
                    projectName: "",// 项目名称
                    size: 10,
                    startDate: "",// 开始时间
                    projectCode: "",// 项目编号
                    category: "",// 类型
                    prjStatus: "在建",// 项目状态
                    isKq: ""// 是否考勤:是,否
                }
                this.getTableData()
            },
            //导出
            handleExport(){
                const { startDate, endDate, projectName, workerName, corpName, areaCode, projectCode, category, prjStatus, isKq } = this.formInline
                this.axios({
                    method: 'post',
                    url:'/worker/sx/projectcorpkeyposition/export',
                    responseType:'arraybuffer',
                    data: {
                        startDate,
                        endDate,
                        projectName,
                        workerName,
                        corpName,
                        areaCode,
                        size: this.pageSize,
                        current: this.page, projectCode, category, prjStatus, isKq
                    },
                }).then( (response)=> {
                    this.common.download(response,'关键岗位预警.xls','application/vnd.ms-excel');
                });
            },
            /*处理操作*/
            handleDeal(name, row,id){
                this.$router.push({
                    name: name,
                    query: {
                       projectId:id
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                const { startDate, endDate, projectName, workerName, corpName, areaCode, projectCode, category, prjStatus, isKq } = this.formInline
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/worker/sx/projectcorp/keyposition',
                    data: {
                        startDate,
                        endDate,
                        projectName,
                        workerName,
                        corpName,
                        areaCode: areaCode,
                        size: this.pageSize,
                        current: this.page, projectCode, category, prjStatus, isKq
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.list.map((item)=>{
                            return {
                                ...item,
                                isManager:item.isManager === "1" ? "是" : "否",
                                isChiefInspector:item.isChiefInspector === "1" ? "是" : "否"
                            }

                        })
                    }
                    
                    for(let i = 0;i<this.tableData.length;i++){
                        let arr = [], brr = []
                        if(String(this.tableData[i].manager).indexOf(",") !== -1){
                             arr = this.tableData[i].manager.split(',');
                              this.tableData[i].manager = '';
                                for(var value of arr) {
                                    this.tableData[i].manager += '<p>' + value + '</p>'
                                }
                            }else {
                                this.tableData[i].manager = this.tableData[i].manager;
                            }
                            if(String(this.tableData[i].chiefInspector).indexOf(",") !== -1){
                             brr = this.tableData[i].chiefInspector.split(',');
                              this.tableData[i].chiefInspector = '';
                                for(var value of brr) {
                                    this.tableData[i].chiefInspector += '<p>' + value + '</p>'
                                }
                            }else {
                                this.tableData[i].chiefInspector = this.tableData[i].chiefInspector;
                            }
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped>
.cover-table>>>.ivu-table-cell{
        white-space: nowrap !important;
        /* min-width: 210px !important;
        width:auto !important; */
}
</style>
